import { IssuePassport } from './IssuePassport';

export type { IssuedDataType } from './Types';

export default IssuePassport;
